import React from "react";
import { useDispatch } from "react-redux";
import { USER_LOGOUT } from "../../../redux/types/auth.types";

const SideBar = () => {

  const dispach = useDispatch();
  const sidebar = [
    { title: "Dashboard", icon: "/img/Dashboard.svg", type: [] },
    { title: "Risk Assessment Tools", icon: "/img/Risk.svg", type: [] },
    { title: "Educational Resources", icon: "/img/Education.svg", type: [] },
    {
      title: "More",
      icon: "/img/more2.svg",
      type: [
        "Liquidity Analysis",
        "Impact Investing & ESG data",
        "Tax Implications",
        "Stress Testing",
        "Collaboration",
        "Download App",
      ],
    },
  ];

  const logOut = () => {
    dispach({ type: USER_LOGOUT })
  }

  const SideBarBottom = [
    { title: "User Profile", icon: "/img/userprofile.svg" },
    { title: "Help Centre", icon: "/img/call.svg" },
    { title: "Log out", icon: "/img/Logout.svg", action: logOut },
  ];

  return (
    <div className="md:fixed w-72 bg-white h-screen text-sm md:text-lg md:p-4 md:border-r-2 transition-all duration-500">
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col gap-4">
          <img className="h-12 w-auto mb-10" src="/img/Logo.svg" alt="" />
          {sidebar.map((item, index) => (
            <div key={index} className="flex flex-col gap-1">
              <div className="flex justify-start items-center gap-2">
                <div>
                  <img className="h-5 w-5" src={item.icon} alt="" />
                </div>
                <div className=" block  font-semibold">{item.title}</div>
              </div>
              {item.type && item.type.length > 0 && (
                <div className="pl-8 p-2 flex-col gap-3 flex">
                  {item.type.map((subtype, subIndex) => (
                    <div
                      key={subIndex}
                      className="text-xs md:text-base font-normal text-[#6F6F6F]"
                    >
                      {subtype}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="flex  flex-col gap-4">
          {SideBarBottom.map((idx, index) => (
            <div onClick={idx?.action} key={index} className="flex flex-col gap-1 cursor-pointer">
              <div className="flex justify-center md:justify-start items-center gap-2">
                <div>
                  <img className="h-5 w-5" src={idx.icon} alt="" />
                </div>
                <div className=" block  font-semibold">{idx.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SideBar;
